export const charityConstants = {
	ADD_CHARITY_REQUEST: 		"ADD_CHARITY_REQUEST",
	ADD_CHARITY_SUCCESS: 		"ADD_CHARITY_SUCCESS",
	ADD_CHARITY_FAILURE: 		"ADD_CHARITY_FAILURE",
	GET_CHARITY_REQUEST: 		"GET_CHARITY_REQUEST",
	GET_CHARITY_SUCCESS: 		"GET_CHARITY_SUCCESS",
	GET_CHARITY_FAILURE: 		"GET_CHARITY_FAILURE",
	DELETE_CHARITY_REQUEST: 	"DELETE_CHARITY_REQUEST",
	DELETE_CHARITY_SUCCESS: 	"DELETE_CHARITY_SUCCESS",
	DELETE_CHARITY_FAILURE: 	"DELETE_CHARITY_FAILURE",
	STATUS_CHARITY_REQUEST: 	"STATUS_CHARITY_REQUEST",
	STATUS_CHARITY_SUCCESS: 	"STATUS_CHARITY_SUCCESS",
	STATUS_CHARITY_FAILURE: 	"STATUS_CHARITY_FAILURE",
	GET_CHARITYDETAIL_REQUEST: 	"GET_CHARITYDETAIL_REQUEST",
	GET_CHARITYDETAIL_SUCCESS: 	"GET_CHARITYDETAIL_SUCCESS",
	GET_CHARITYDETAIL_FAILURE:  "GET_CHARITYDETAIL_FAILURE",
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/charityConstants.js